import { useSyncExternalStore } from 'react'

import {
  indicatorsSnapshot,
  setIndicators,
  subscribeIndicators,
  type Indicator,
} from '@/lib/indicators'

/**
 * Liste des indicateurs, partagée par tous les graphiques ouverts.
 *
 * Même signature qu'un `useState` pour que les composants ne sachent rien du
 * dépôt qui est derrière. Ajouter une moyenne dans un panneau la fait
 * apparaître dans les autres à la même image.
 */
export function useIndicators() {
  const indicators = useSyncExternalStore(
    subscribeIndicators,
    indicatorsSnapshot,
    indicatorsSnapshot,
  )
  return [indicators, setIndicators] as const
}

export type { Indicator }
